import { Component, inject } from '@angular/core';
import { ToastService } from '../services/toast.service';
import { ToastComponent } from './toast.component';

@Component({
  selector: 'app-toast-container',
  imports: [ToastComponent],
  template: `
    @for (toast of toastService.visibleToasts(); track toast.id) {
      <app-toast [toast]="toast" />
    }
  `,
  host: {
    class: 'pointer-events-none fixed bottom-0 right-0 z-999999 w-full',
    'aria-live': 'polite'
  }
})
export class ToastContainerComponent {
  protected readonly toastService = inject(ToastService);
}
